import React from "react";
import ContactForm from "../components/ContactForm/ContactForm";
import ContactDetails from "../components/ContactDetails/ContactDetails";
const Contact = () => {
  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Connect with Risen Star Goods</h1>
            <p>
              We're here to answer inquiries and facilitate global partnerships.
            </p>
          </div>
        </div>
      </section>

      <section className="contact-container">
        <div className="contact-wrapper">
          <ContactForm />
          <ContactDetails />
        </div>
      </section>
    </div>
  );
};

export default Contact;
